/**
 * View mode enum for invoice validation display
 * Note: This was extracted from ModalValidateInvoice component to allow safe removal
 */
export enum ViewMode {
  STRUCTURED = 'structured',
  RAW = 'raw',
}
